import * as angular from "angular";
import {IController} from "angular";
import {AgentType} from "../../types/agent.type";

export class AgentIconCtrl implements IController {

  agentType: any;

  public agentTypes: typeof AgentType = AgentType;

}

angular
  .module('bringoz.admin.agents')
  .component('agentIcon', {
    bindings: {
      agentType: '<'
    },
    template: require('./agent-icon.html').default,
    controller: AgentIconCtrl
  });
